// Shared QR-render constants. Must mirror the backend's
// ZxingQrImageRenderer.kt companion object so the client + server outputs
// stay pixel-identical (or as close as antialiasing + font hinting allows).

export const MARGIN_MODULES = 1;

// SIMPLE / ROUNDED frame — 1-module-thick ring in fg colour, outside the
// quiet zone. The quiet zone stays intact between the modules and the
// frame so scan reliability is unaffected. ROUNDED adds a uniform-
// thickness corner radius (outer + inner rounded, inner = outer - width).
// SHIELD and CALL_TO_ACTION are still TODO.
export const FRAME_SIMPLE_WIDTH_MODULES = 1;
export const FRAME_ROUNDED_OUTER_RADIUS_MODULES = 2;

export const PATCH_WIDTH_MODULES = 6;
export const PATCH_HEIGHT_MODULES = 2;
// Inner padding between the rendered glyph cluster and the patch edge.
// Asymmetric on purpose: the watermark hugs the top-left edge tightly
// (1 module-pixel ≈ 0.04 modules at size=750) and keeps breathing room
// on the bottom-right where the outer image edge is close.
export const PATCH_TEXT_PADDING_LEFT_MODULES = 0.7;
export const PATCH_TEXT_PADDING_RIGHT_MODULES = 0.5;
export const PATCH_V_PADDING_TOP_MODULES = 0.5;
export const PATCH_V_PADDING_BOTTOM_MODULES = 0.0;
// Outer margin per side, in module units. The patch is anchored to the
// image's bottom-right corner:
//   - RIGHT  = distance from patch right edge to image right edge
//   - BOTTOM = distance from patch bottom edge to image bottom edge
//   - LEFT   = extra background width to the *left* of the patch
//              (positive → halo into the code; 0 → patch edge as-is)
//   - TOP    = extra background height *above* the patch
//              (positive → halo into the code; 0 → patch edge as-is)
// Setting all four to 0 means the patch is flush with the bottom-right
// corner and has no halo on top/left.
export const PATCH_OUTER_MARGIN_TOP_MODULES = -0.0;
export const PATCH_OUTER_MARGIN_RIGHT_MODULES = 0.5;
export const PATCH_OUTER_MARGIN_BOTTOM_MODULES = 1.0;
export const PATCH_OUTER_MARGIN_LEFT_MODULES = -0.5;

export const BRAND_TEXT = "qrody";

// Visible glyph cluster height as a fraction of font-size for a
// lowercase-only sans-serif string — used to clamp font-size against
// the patch height.
export const VISIBLE_GLYPH_TO_FONTSIZE_RATIO = 0.9;
